import type { ListItem } from '../LiliAutoComplete';
import { forwardRef } from 'react';
import { Heading } from '../../../tokens';
import { ReactComponent as SelectedIcon } from '../../../../assets/shared/ic-shared-checkmark.svg';
import { twMerge } from 'tailwind-merge';

interface DefaultItemTemplateProps {
  item: ListItem;
  isSelected: boolean;
  isHighlighted?: boolean;
  onItemSelection: (item: ListItem) => void;
}

export const DefaultItemTemplate = forwardRef<HTMLButtonElement, DefaultItemTemplateProps>(
  ({ onItemSelection, item, isSelected, isHighlighted = false }, ref) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onItemSelection(item);
    };

    const className = twMerge(
      'w-full flex rounded-[4px] item-baseline py-[10px] px-[20px] border-b border-outline-primary-bw-02 hover:bg-outline-primary-bw-02 relative',
      isSelected && 'bg-surface-brand-action-00',
      isHighlighted && 'bg-outline-primary-bw-01'
    );
    return (
      <button key={item.value} onClick={handleClick} className='w-full px-[8px] py-[4px]'>
        <button ref={ref} type='button' onClick={handleClick} className={className}>
          <Heading.H10 className={isSelected ? 'text-text-brand-primary' : ''}>
            {item.title}
          </Heading.H10>
          {isSelected && (
            <SelectedIcon className='text-text-brand-primary stroke-text-brand-primary absolute right-[12px] top-[50%] transform -translate-y-1/2 pointer-events-none' />
          )}
        </button>
      </button>
    );
  }
);

DefaultItemTemplate.displayName = 'DefaultItemTemplate';
